import React from "react";
import * as Sentry from "@sentry/react";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        Sentry.captureMessage(error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="p-4 text-center">
                    <h1>Oops! Something went wrong.</h1>
                    <p>Please try refresh the browser and see if it fixes the issue.</p>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;